(function () {
  'use strict';

  function hasBadControl(value) {
    return /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/.test(value);
  }

  function quotePayload(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) throw new Error('empty');
    if (cart.items.length > 100) throw new Error('limit');
    var lostBitsQuantities = {};
    var items = cart.items.map(function (item) {
      var rawVariant = item.variant_id || item.id || '';
      var variant = String(rawVariant);
      if ((typeof rawVariant === 'number' && !Number.isSafeInteger(rawVariant)) || !/^[1-9][0-9]{0,19}$/.test(variant) || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || item.quantity > 2147483647) throw new Error('invalid');
      var properties = item.properties || {};
      if (typeof properties !== 'object' || Array.isArray(properties)) throw new Error('invalid');
      var propertyNames = Object.keys(properties);
      if (propertyNames.length > 20) throw new Error('limit');
      propertyNames.forEach(function (key) {
        if (!key.trim() || key.length > 100 || hasBadControl(key) || typeof properties[key] !== 'string' || properties[key].length > 1000 || hasBadControl(properties[key])) throw new Error('invalid');
      });
      var line = { variant_id: variant, quantity: item.quantity };
      if (String(item.product_id) === '16312274223491') lostBitsQuantities[variant] = (lostBitsQuantities[variant] || 0) + item.quantity;
      if (Object.keys(properties).length) line.properties = properties;
      if (item.selling_plan_allocation) throw new Error('subscription');
      return line;
    });
    if (Object.keys(lostBitsQuantities).some(function (id) { return lostBitsQuantities[id] < 100; })) throw new Error('minimum');
    // No price, discount, approval or company ID from the browser is accepted as authority.
    // Variant IDs, quantity, and every line property are retained without truncation.
    var result = { v: 1, source: 'guest_quote', items: items };
    if (cart.note) {
      if (typeof cart.note !== 'string' || hasBadControl(cart.note)) throw new Error('invalid');
      result.note = cart.note;
    }
    if (cart.attributes && Object.keys(cart.attributes).length) {
      if (typeof cart.attributes !== 'object' || Array.isArray(cart.attributes)) throw new Error('invalid');
      result.attributes = cart.attributes;
    }
    return JSON.stringify(result);
  }

  function validateSubmission(payload, fields) {
    var quote = JSON.parse(payload);
    var email = String(fields.email || '');
    // Shop's authenticated lead capture can keep the email outside the input's
    // DOM value. Reserve the maximum email size; native Forms still validates it.
    var emailForSizing = email || 'x'.repeat(254);
    var copied = ['company', 'first_name', 'email', 'delivery_address', 'notes'].map(function (key) { return key === 'email' ? emailForSizing : String(fields[key] || ''); });
    copied.push(quote.note || '');
    if (copied.some(hasBadControl)) throw new Error('contact');
    if (email) {
      var parts = email.split('@');
      if (email.length > 254 || /\s/.test(email) || parts.length !== 2 || parts[0].length > 64 || !parts[0] || parts[0].startsWith('.') || parts[0].endsWith('.') || parts[0].includes('..') || !/^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+$/.test(parts[0]) || !/^(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?$/.test(parts[1])) throw new Error('email');
    }
    var copiedText = copied.join('\n');
    if (copiedText.length > 10000) throw new Error('limit');
    // Project only request data to bound Flow's double-encoded output. This is a
    // size check, never a substitute for server-side variant/access validation.
    var lines = quote.items.map(function (item) {
      var line = { variantId: 'gid://shopify/ProductVariant/' + item.variant_id, quantity: item.quantity };
      if (item.properties && Object.keys(item.properties).length) line.customAttributes = Object.entries(item.properties).map(function (entry) { return { key: entry[0], value: entry[1] }; });
      return line;
    });
    function encodedBytes(value) { return new TextEncoder().encode(JSON.stringify(JSON.stringify(value))).length; }
    var bytes = encodedBytes(lines) + encodedBytes(String(fields.company || '')) + encodedBytes(String(fields.first_name || '(not provided)')) + 2 * encodedBytes(emailForSizing) + encodedBytes(String(fields.delivery_address || '')) + encodedBytes(quote.note || '(not provided)') + encodedBytes(String(fields.notes || '(not provided)'));
    // 14 KB reserves the fixed note/metadata/tags, source reference, and up to
    // 100 full variant IDs + lookup query. Do not truncate to satisfy this cap.
    if (bytes + 14000 > 48000) throw new Error('limit');
  }

  function nativeField(root, id) {
    if (!root) return null;
    var found = Array.from(root.querySelectorAll('input,textarea')).find(function (field) { return field.id === id || field.name === id; });
    if (found) return found;
    var elements = root.querySelectorAll('*');
    for (var i = 0; i < elements.length; i++) {
      if (!elements[i].shadowRoot) continue;
      found = nativeField(elements[i].shadowRoot, id);
      if (found) return found;
    }
    return null;
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { quotePayload: quotePayload, validateSubmission: validateSubmission };
  if (typeof document === 'undefined') return;

  function text(tag, className, value) {
    var el = document.createElement(tag);
    el.className = className;
    el.textContent = value;
    return el;
  }

  async function mount(panel) {
    if (panel.dataset.hpQuoteMounted) return;
    panel.dataset.hpQuoteMounted = 'true';
    var de = panel.dataset.locale === 'de';
    var messages = de ? {
      empty: 'Ihre Artikelliste ist leer. Fügen Sie zuerst die gewünschten Produkte hinzu.',
      unavailable: 'Ihre vollständige Artikelliste konnte nicht geladen werden. Bitte laden Sie die Seite neu. Es wurde keine Anfrage gesendet.',
      tooLong: 'Ihre Liste ist für dieses Formular zu umfangreich. Es wurde nichts gekürzt oder gesendet. Bitte rufen Sie uns an, damit wir die gesamte Anfrage gemeinsam aufnehmen können.',
      changed: 'Ihre Artikelliste hat sich geändert. Bitte laden Sie diese Seite neu und prüfen Sie die aktuelle Liste, bevor Sie senden.',
      summary: 'Positionen', quantity: 'Stück', article: 'Artikel', note: 'Ihre Notiz', payload: 'Artikelliste für HP',
      ready: 'Die vollständige Artikelliste ist im Formular enthalten.',
      verifying: 'Artikelliste wird geprüft …', unsupported: 'Diese Liste enthält eine Bestellart oder Konfiguration, die HP direkt prüfen muss. Bitte kontaktieren Sie uns telefonisch.',
      contact: 'Bitte prüfen Sie Ihre Kontaktdaten. Unzulässige Steuerzeichen sind enthalten; es wurde nichts gesendet.',
      email: 'Bitte geben Sie eine vollständige E-Mail-Adresse ein, zum Beispiel name@firma.de. Es wurde nichts gesendet.',
      minimum: 'Lost Bits sind ab 100 Stück je Größe erhältlich. Für kleinere Mengen rufen Sie uns bitte an. Ihre Menge wurde nicht geändert und es wurde nichts gesendet.',
      details: 'Diese Anfrage enthält zu viele Angaben für die automatische Verarbeitung. Es wurde nichts gekürzt oder gesendet. Ihre Eingaben bleiben erhalten. Bitte rufen Sie uns an, damit wir die vollständige Anfrage aufnehmen können.'
    } : {
      empty: 'Your item list is empty. Add the products you need before requesting a quotation.',
      unavailable: 'Your complete item list could not be loaded. Please reload this page. No enquiry has been sent.',
      tooLong: 'Your list is too large for this form. Nothing has been shortened or sent. Please call us so we can capture the complete request together.',
      changed: 'Your item list has changed. Please reload this page and review the updated list before sending.',
      summary: 'lines', quantity: 'pcs', article: 'Article', note: 'Your note', payload: 'Item list for HP',
      ready: 'Your complete item list is included in the form.',
      verifying: 'Checking your item list …', unsupported: 'This list contains an order type or configuration that HP needs to review directly. Please call us.',
      contact: 'Please check your contact details. Unsupported control characters are included; nothing has been sent.',
      email: 'Please enter a complete email address, for example name@company.com. Nothing has been sent.',
      minimum: 'Lost Bits require at least 100 pieces per size. Please call us for smaller quantities. Your quantity has not been changed and nothing has been sent.',
      details: 'This request contains too much detail for automatic processing. Nothing has been shortened or sent. Your input is preserved. Please call us so we can capture the complete request.'
    };
    var status = panel.querySelector('[data-hp-quote-status]');
    var errorBox = panel.querySelector('[data-hp-quote-error]');
    var formBox = panel.querySelector('[data-hp-quote-form]');
    var list = panel.querySelector('[data-hp-quote-items]');
    var root = panel.dataset.rootUrl || '/';
    var cartUrl = new URL(root.replace(/\/?$/, '/') + 'cart.js', window.location.origin);
    var currentPayload = '';
    var checking = false;
    var verifiedSubmit = false;

    function fail(message) {
      status.textContent = '';
      errorBox.textContent = message;
      errorBox.hidden = false;
      formBox.hidden = true;
      formBox.setAttribute('aria-busy', 'false');
    }
    async function getCart() {
      var response = await fetch(cartUrl.href, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('network');
      return response.json();
    }
    function setPayload(field, value) {
      var setter = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set;
      setter.call(field, value);
      field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
      field.readOnly = true;
      field.setAttribute('aria-label', messages.payload);
      if (field.value !== value) throw new Error('field');
      // This local machine field is not a second list for the customer to edit.
      // Its complete readable counterpart is the product summary alongside the form.
      var wrapper = field.parentElement;
      if (wrapper && wrapper.querySelectorAll('input,textarea').length === 1 && wrapper.querySelector('label')) {
        wrapper.hidden = true;
        // Forms' own display:flex overrides the browser's default [hidden] rule.
        wrapper.style.setProperty('display', 'none', 'important');
      }
    }
    function draw(cart) {
      list.replaceChildren();
      cart.items.forEach(function (item) {
        var row = document.createElement('li');
        row.className = 'hp-guest-quote__item';
        var image = document.createElement('img');
        image.alt = '';
        image.loading = 'lazy';
        if (item.image) image.src = item.image;
        else image.hidden = true;
        row.append(image);
        var details = document.createElement('div');
        details.append(text('p', 'hp-guest-quote__item-title', item.product_title || item.title || ''));
        var options = [];
        if (item.variant_title && item.variant_title !== 'Default Title') options.push(item.variant_title);
        if (item.sku) options.push(messages.article + ': ' + item.sku);
        Object.keys(item.properties || {}).forEach(function (name) {
          if (name.charAt(0) !== '_' && item.properties[name] !== '') options.push(name + ': ' + String(item.properties[name]));
        });
        if (options.length) details.append(text('p', 'hp-guest-quote__item-options', options.join('\n')));
        row.append(details, text('span', 'hp-guest-quote__item-qty', item.quantity + ' ' + messages.quantity));
        list.append(row);
      });
      var note = panel.querySelector('[data-hp-quote-cart-note]');
      if (cart.note) { note.textContent = messages.note + ': ' + cart.note; note.hidden = false; }
      status.textContent = cart.items.length + ' ' + messages.summary + ' · ' + cart.item_count + ' ' + messages.quantity;
    }

    try {
      var cart = await getCart();
      currentPayload = quotePayload(cart);
      draw(cart);
    } catch (error) {
      fail(error.message === 'empty' ? messages.empty : error.message === 'limit' ? messages.tooLong : error.message === 'minimum' ? messages.minimum : ['subscription', 'invalid'].includes(error.message) ? messages.unsupported : messages.unavailable);
      return;
    }
    var attempts = 0;
    // Shopify Forms renders asynchronously within an open shadow root. The form remains
    // hidden until the full payload is present; never allow a partial or empty item list.
    formBox.hidden = false;
    formBox.style.visibility = 'hidden';
    var timer = window.setInterval(function () {
      attempts++;
      var field = nativeField(formBox, panel.dataset.payloadField);
      if (!field) {
        if (attempts >= 80 || !panel.isConnected) { window.clearInterval(timer); fail(messages.unavailable); }
        return;
      }
      window.clearInterval(timer);
      var max = field.maxLength > 0 ? Math.min(field.maxLength, 16000) : 16000;
      if (currentPayload.length > max) { fail(messages.tooLong); return; }
      try { setPayload(field, currentPayload); }
      catch (_) { fail(messages.unavailable); return; }
      formBox.style.visibility = '';
      formBox.setAttribute('aria-busy', 'false');
      var nativeForm = field.closest('form');
      if (!nativeForm) { fail(messages.unavailable); return; }
      nativeForm.addEventListener('submit', function (event) {
        if (verifiedSubmit) { verifiedSubmit = false; return; }
        event.preventDefault();
        event.stopImmediatePropagation();
        if (checking) return;
        var contactFields = {};
        ['company', 'delivery_address', 'notes', 'first_name', 'email'].forEach(function (key) {
          var input = nativeField(formBox, ['first_name', 'email'].includes(key) ? key : 'custom#' + key);
          contactFields[key] = input ? input.value : '';
        });
        try { validateSubmission(currentPayload, contactFields); }
        catch (error) {
          errorBox.textContent = error.message === 'email' ? messages.email : error.message === 'contact' ? messages.contact : messages.details;
          errorBox.hidden = false;
          return;
        }
        errorBox.hidden = true;
        checking = true;
        var submitter = event.submitter;
        status.textContent = messages.verifying;
        getCart().then(function (fresh) {
          if (quotePayload(fresh) !== currentPayload || field.value !== currentPayload) throw new Error('changed');
          verifiedSubmit = true;
          status.textContent = messages.ready;
          nativeForm.requestSubmit(submitter || undefined);
        }).catch(function (error) {
          verifiedSubmit = false;
          fail(error.message === 'changed' ? messages.changed : error.message === 'minimum' ? messages.minimum : messages.unavailable);
        }).finally(function () { checking = false; });
      }, true);
      // Native fields enforce the contact validation. Cart content is a request only;
      // Flow must validate variants/quantities and never trust browser-supplied prices.
    }, 250);
  }
  function init() { document.querySelectorAll('[data-hp-guest-quote]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
